module.exports = __webpack_public_path__ + "static/img/products application_Tape PVC1.a11477a8.jpg";